import type { ReactNode } from 'react';

interface AdminPageProps {
  title: string;
  description?: string;
  actions?: ReactNode;
  children: ReactNode;
}

/** Shared chrome for every admin section: a serif title header + content well. */
export function AdminPage({ title, description, actions, children }: AdminPageProps) {
  return (
    <div className="min-h-dvh bg-app-bg text-app-fg">
      <div className="px-6 py-6">
        <div className="flex items-start justify-between gap-4 mb-6">
          <div className="min-w-0">
            <h1 className="text-2xl md:text-3xl font-semibold text-app-fg mb-1">{title}</h1>
            {description && <p className="text-sm text-app-muted">{description}</p>}
          </div>
          {actions && <div className="shrink-0 flex items-center gap-2">{actions}</div>}
        </div>
        {children}
      </div>
    </div>
  );
}

export default AdminPage;
